module.exports = __webpack_public_path__ + "static/media/SZ.3fd422e9.svg";